// @ts-nocheck
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Loader } from "../Loaders/Loader";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";

export const LoadBootBtn = (props) => {
  const { t } = useTranslation();
  const { text, url, className, image } = props;
  const [isloading, setLoading] = useState(false);

  const buttonClick = () => {
    setLoading(true);
  };
  return (
    <a className={className} href={url} onClick={buttonClick} style={{ position: "relative" }}>
      <span style={{ display: "flex", alignItems: "center", width: "max-content" }}>
        {isloading ? (
          <>
            <span style={{ marginTop: "-4px" }}>
              <Loader loaderColor="main-green" loaderSize={21} />
            </span>
            <span style={{ paddingLeft: "10px", fontSize: "14px" }}>{t("LoadBootBtn.起動中")}</span>
          </>
        ) : (
          <>
            <img src={getImageUrl(image)} width={25} height={25} />
            <span style={{ paddingLeft: "6px", fontSize: "14px" }}>{text}</span>
          </>
        )}
      </span>
    </a>
  );
};

LoadBootBtn.propTypes = {
  text: PropTypes.string,
  url: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.string,
};
